import { z } from "zod";
import { ClientId, DateSchema } from "../../Types";
import { GoalBasedFinancialPlanIdSchema, GoalBasedFinancialPlanInsuranceIdSchema, } from "../ids";
export const GoalBasedInsuranceTypes = [
    "Life",
    "Disability",
    "LongTerm",
    "PropertyAndCasualty",
];
export const GoalBasedInsuranceTypeSchema = z.enum(GoalBasedInsuranceTypes);
export const GoalBasedInsuranceTypeLabels = [
    "Life",
    "Disability",
    "Long Term",
    "Property And Casualty",
];
export const GoalBasedInsuranceTypeLabelSchema = z.enum(GoalBasedInsuranceTypeLabels);
export const GoalBasedInsuranceTypeMap = {
    Life: "Life",
    Disability: "Disability",
    LongTerm: "Long Term",
    PropertyAndCasualty: "Property And Casualty",
};
//
export const GoalBasedLifeInsuranceTypes = [
    "TermLife",
    "WholeLife",
    "GroupLife",
    "UniversalLife",
    "IndexedUniversalLife",
];
export const GoalBasedLifeInsuranceTypeSchema = z.enum(GoalBasedLifeInsuranceTypes);
export const GoalBasedLifeInsuranceTypeLabels = [
    "Term Life",
    "Whole Life",
    "Group Life",
    "Universal Life",
    "Indexed Universal Life",
];
export const GoalBasedLifeInsuranceTypeLabelSchema = z.enum(GoalBasedLifeInsuranceTypeLabels);
export const GoalBasedLifeInsuranceTypeMap = {
    TermLife: "Term Life",
    WholeLife: "Whole Life",
    GroupLife: "Group Life",
    UniversalLife: "Universal Life",
    IndexedUniversalLife: "Indexed Universal Life",
};
export const GoalBasedFinancialPlanInsuranceResponseSchema = z.object({
    planInsuranceId: GoalBasedFinancialPlanInsuranceIdSchema,
    goalBasedFinancialPlanId: GoalBasedFinancialPlanIdSchema,
    insuranceType: GoalBasedInsuranceTypeSchema,
    name: z.string(),
    owner: ClientId,
    amount: z.string(),
    insuranceCarrier: z.string(),
    policyNumber: z.string(),
    filePathUrl: z.string().url().optional(),
    lifeInsuranceType: GoalBasedLifeInsuranceTypeSchema.optional(),
    createdAt: DateSchema,
    updatedAt: DateSchema,
});
export const GoalBasedFinancialPlanInsurancePostRequestSchema = z.union([
    z.object({
        insuranceType: GoalBasedInsuranceTypeSchema.exclude(["Life"]),
        name: z.string(),
        owner: z.string(),
        amount: z.string(),
        insuranceCarrier: z.string(),
        policyNumber: z.string(),
        file: z.instanceof(Blob).optional(),
    }),
    z.object({
        insuranceType: GoalBasedInsuranceTypeSchema.extract(["Life"]),
        name: z.string(),
        owner: z.string(),
        amount: z.string(),
        insuranceCarrier: z.string(),
        policyNumber: z.string(),
        lifeInsuranceType: GoalBasedLifeInsuranceTypeSchema,
        file: z.instanceof(Blob).optional(),
    }),
]);
export const GoalBasedFinancialPlanInsurancePatchRequestSchema = z.union([
    z
        .object({
        insuranceType: GoalBasedInsuranceTypeSchema.exclude(["Life"]),
        name: z.string(),
        owner: z.string(),
        amount: z.string(),
        insuranceCarrier: z.string(),
        policyNumber: z.string(),
        file: z.instanceof(Blob).optional(),
    })
        .partial(),
    z
        .object({
        insuranceType: GoalBasedInsuranceTypeSchema.extract(["Life"]),
        name: z.string(),
        owner: z.string(),
        amount: z.string(),
        insuranceCarrier: z.string(),
        policyNumber: z.string(),
        lifeInsuranceType: GoalBasedLifeInsuranceTypeSchema,
        file: z.instanceof(Blob).optional(),
    })
        .partial(),
]);
export const GoalBasedFinancialPlanInsuranceDeleteResponseSchema = z.object({
    message: z.string(),
});
//# sourceMappingURL=types.js.map